import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Event } from '../../types/Event';
import UpcomingEventCard from './UpcomingEventCard';
import { useAuth } from '../../contexts/AuthContext';

interface EventsListProps {
  events: Event[];
  onShowParticipants: (event: Event, e: React.MouseEvent) => void;
  onEdit: (event: Event) => void;
  onDelete: (eventId: string) => void;
  onEventClick: (event: Event) => void;
  familyMembers?: any[];
  onLocationClick: (locationId: string) => void;
}

const EventsList: React.FC<EventsListProps> = ({
  events,
  onShowParticipants,
  onEdit,
  onDelete,
  onEventClick,
  familyMembers = [],
  onLocationClick
}) => {
  const { user } = useAuth();

  return (
    <Box sx={{ mb: 4 }}>
      {!user && (
        <Typography variant="caption" sx={{ display: 'block', color: '#aaa', mt: 1 }}>
          * Connectez-vous et devenez adhérent pour pouvoir vous inscrire aux événements.
        </Typography>
      )}

      <Box sx={{ mt: 2 }}>
        <Grid container spacing={3}>
          {events.map(event => (
            <Grid item xs={12} key={event.id}>
              <UpcomingEventCard
                event={event}
                onShowParticipants={onShowParticipants}
                onEdit={onEdit}
                onDelete={onDelete}
                onClick={onEventClick}
                familyMembers={familyMembers}
                onLocationClick={onLocationClick}
              />
            </Grid>
          ))}
          {events.length === 0 && (
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ color: '#aaa', textAlign: 'center', py: 4 }}>
                Aucun événement à venir
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
};

export default React.memo(EventsList);
